import { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Lock, ArrowLeft } from 'lucide-react';
import { toast } from 'sonner';
import api from '@/utils/api';

const AdminChangePassword = () => {
  const [formData, setFormData] = useState({
    old_password: '',
    new_password: '',
    confirm_password: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.new_password !== formData.confirm_password) {
      toast.error('Password baru dan konfirmasi password tidak cocok');
      return;
    }

    if (formData.new_password.length < 6) {
      toast.error('Password baru minimal 6 karakter');
      return;
    }

    setLoading(true);
    try {
      await api.post('/auth/change-password', {
        old_password: formData.old_password,
        new_password: formData.new_password
      });
      toast.success('Password berhasil diubah!');
      setFormData({ old_password: '', new_password: '', confirm_password: '' });
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gagal mengubah password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <nav className="border-b border-zinc-800 bg-background-paper/50 backdrop-blur-xl sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <Link to="/admin/dashboard" className="flex items-center space-x-3">
              <img src="/zero-logo.png" alt="Logo" className="w-10 h-10 object-contain rounded-md" />
              <span className="text-2xl font-heading font-black italic text-primary uppercase">Admin Panel</span>
            </Link>
            <Link to="/admin/dashboard" className="text-zinc-400 hover:text-primary flex items-center gap-2">
              <ArrowLeft className="w-5 h-5" />
              <span>Dashboard</span>
            </Link>
          </div>
        </div>
      </nav>

      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full mb-4">
              <Lock className="w-8 h-8 text-primary" />
            </div>
            <h1 className="text-3xl font-heading font-bold italic uppercase text-white mb-2">Ubah Password</h1>
            <p className="text-zinc-400">Perbarui password akun admin Anda</p>
          </div>

          <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-8">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-semibold text-zinc-300 mb-2">Password Lama</label>
                <input
                  data-testid="old-password-input"
                  type="password"
                  required
                  value={formData.old_password}
                  onChange={(e) => setFormData({ ...formData, old_password: e.target.value })}
                  className="w-full bg-zinc-950 border border-zinc-800 focus:border-primary focus:ring-1 focus:ring-primary text-white rounded-md h-12 px-4 placeholder:text-zinc-600 transition-all outline-none"
                  placeholder="Masukkan password lama"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-zinc-300 mb-2">Password Baru</label>
                <input
                  data-testid="new-password-input"
                  type="password"
                  required
                  minLength={6}
                  value={formData.new_password}
                  onChange={(e) => setFormData({ ...formData, new_password: e.target.value })}
                  className="w-full bg-zinc-950 border border-zinc-800 focus:border-primary focus:ring-1 focus:ring-primary text-white rounded-md h-12 px-4 placeholder:text-zinc-600 transition-all outline-none"
                  placeholder="Minimal 6 karakter"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-zinc-300 mb-2">Konfirmasi Password Baru</label>
                <input
                  data-testid="confirm-password-input"
                  type="password"
                  required
                  value={formData.confirm_password}
                  onChange={(e) => setFormData({ ...formData, confirm_password: e.target.value })}
                  className="w-full bg-zinc-950 border border-zinc-800 focus:border-primary focus:ring-1 focus:ring-primary text-white rounded-md h-12 px-4 placeholder:text-zinc-600 transition-all outline-none"
                  placeholder="Ulangi password baru"
                />
              </div>

              <button
                data-testid="submit-change-password"
                type="submit"
                disabled={loading}
                className="w-full bg-primary text-black hover:bg-primary-hover rounded-none skew-btn px-8 py-3 font-bold uppercase tracking-wider transition-all duration-200 shadow-[4px_4px_0px_0px_#FFFFFF] hover:shadow-[6px_6px_0px_0px_#FFFFFF] disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <span>{loading ? 'Memproses...' : 'Ubah Password'}</span>
              </button>
            </form>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default AdminChangePassword;
